export const keysByUserType = {
  admin: {
    filterKeys: [
      'owned',
      'pending',
      'delayed',
      'completed',
      'cancelled',
      'rejected',
      'rejected-tasks',
      'errored-tasks',
      'mine',
      'following',
      'paused',
      'all',
    ],
    defaultFilterKey: 'owned',
  },
  regularUser: {
    filterKeys: [
      'owned',
      'mine',
      'minePending',
      'mineDelayed',
      'mineCancelled',
      'mineCompleted',
      'minePaused',
      'following',
      'all',
    ],
    defaultFilterKey: 'mine',
  },
} as const

export const requestTopLevelFilterKeys = [...keysByUserType.admin.filterKeys, ...keysByUserType.regularUser.filterKeys] as const
export type RequestTopLevelFilterKey = (typeof requestTopLevelFilterKeys)[number]
